module.exports = __webpack_public_path__ + "static/media/invest-india-logo_01.63d944eb.png";